/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AjaxResponseOfCarnetDto } from '../models/ajax-response-of-carnet-dto';
import { AjaxResponseOfListOfCarnetRouteDto } from '../models/ajax-response-of-list-of-carnet-route-dto';
import { AjaxResponseOfPagedCarnetDtoResponse } from '../models/ajax-response-of-paged-carnet-dto-response';
import { PagedCarnetDtoRequest } from '../models/paged-carnet-dto-request';

@Injectable({
  providedIn: 'root',
})
export class CarnetService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllCarnets
   */
  static readonly GetAllCarnetsPath = '/api/services/app/Carnet/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCarnets()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getAllCarnets$Response(params?: {
    body?: PagedCarnetDtoRequest
  }): Observable<StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CarnetService.GetAllCarnetsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllCarnets$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getAllCarnets(params?: {
    body?: PagedCarnetDtoRequest
  }): Observable<AjaxResponseOfPagedCarnetDtoResponse> {

    return this.getAllCarnets$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>) => r.body as AjaxResponseOfPagedCarnetDtoResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCarnets$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  getAllCarnets$Xml$Response(params?: {
    body?: PagedCarnetDtoRequest
  }): Observable<StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CarnetService.GetAllCarnetsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllCarnets$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  getAllCarnets$Xml(params?: {
    body?: PagedCarnetDtoRequest
  }): Observable<AjaxResponseOfPagedCarnetDtoResponse> {

    return this.getAllCarnets$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>) => r.body as AjaxResponseOfPagedCarnetDtoResponse)
    );
  }

    /**
   * Path part for operation getAllAvailableCarnets
   */
  static readonly GetAllAvailableCarnetsPath = '/api/services/app/Carnet/GetAllAvailable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAvailableCarnets()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getAllAvailableCarnets$Response(params?: {
    body?: PagedCarnetDtoRequest
  }): Observable<StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CarnetService.GetAllAvailableCarnetsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>;
      })
    );
  }
 
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllAvailableCarnets$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getAllAvailableCarnets(params?: {
    body?: PagedCarnetDtoRequest
  }): Observable<AjaxResponseOfPagedCarnetDtoResponse> {

    return this.getAllAvailableCarnets$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>) => r.body as AjaxResponseOfPagedCarnetDtoResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAvailableCarnets$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  getAllAvailableCarnets$Xml$Response(params?: {
    body?: PagedCarnetDtoRequest
  }): Observable<StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CarnetService.GetAllAvailableCarnetsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllAvailableCarnets$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  getAllAvailableCarnets$Xml(params?: {
    body?: PagedCarnetDtoRequest
  }): Observable<AjaxResponseOfPagedCarnetDtoResponse> {

    return this.getAllAvailableCarnets$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfPagedCarnetDtoResponse>) => r.body as AjaxResponseOfPagedCarnetDtoResponse)
    );
  }

  /**
   * Path part for operation getCarnetInfo
   */
  static readonly GetCarnetInfoPath = '/api/services/app/Carnet/GetCarnetInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarnetInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarnetInfo$Response(params?: {
    id?: string;
  }): Observable<StrictHttpResponse<AjaxResponseOfCarnetDto>> {

    const rb = new RequestBuilder(this.rootUrl, CarnetService.GetCarnetInfoPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfCarnetDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCarnetInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarnetInfo(params?: {
    id?: string;
  }): Observable<AjaxResponseOfCarnetDto> {

    return this.getCarnetInfo$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfCarnetDto>) => r.body as AjaxResponseOfCarnetDto)
    );
  }

  /**
   * Path part for operation getRoutesList
   */
  static readonly GetRoutesListPath = '/api/services/app/Carnet/GetRoutesList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoutesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoutesList$Response(params?: {
  }): Observable<StrictHttpResponse<AjaxResponseOfListOfCarnetRouteDto>> {

    const rb = new RequestBuilder(this.rootUrl, CarnetService.GetRoutesListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfListOfCarnetRouteDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRoutesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoutesList(params?: {
  }): Observable<AjaxResponseOfListOfCarnetRouteDto> {

    return this.getRoutesList$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfListOfCarnetRouteDto>) => r.body as AjaxResponseOfListOfCarnetRouteDto)
    );
  }

}
